import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { apiRequest } from "../../services";
import {useDispatch, useSelector} from "react-redux";
import "./HistoryTransaction.css";

const HistoriqueTransaction = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const accountData = location.state?.account;
  const userData = useSelector((state) => state.users);
  const [transactionData, setTransactionData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("fr-FR").format(amount) + " FCFA";
  };

  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };

  const getTransactionIcon = (type) => {
    switch(type) {
      case 'depot':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
          </svg>
        );
      case 'RETRAIT':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
          </svg>
        );
      case 'SAVING':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
        );
      case 'WITHDRAWAL_PENALTY':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
          </svg>
        );
      default:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
          </svg>
        );
    }
  };

  const getTransactionClass = (type) => {
    switch(type) {
      case 'depot':
        return "historique-transaction-depot";
      case 'RETRAIT':
        return "historique-transaction-retrait";
      case 'SAVING':
        return "historique-transaction-saving";
      case 'WITHDRAWAL_PENALTY':
        return "historique-transaction-penalty";
      default:
        return "historique-transaction-default";
    }
  };

  const getTransactionLabel = (type) => {
    switch(type) {
      case 'depot': return t("Dépôt");
      case 'RETRAIT': return t("Retrait");
      case 'SAVING': return t("Épargne");
      case 'WITHDRAWAL_PENALTY': return t("Pénalité");
      default: return type;
    }
  };

  const getStatusClass = (status) => {
    return "historique-status-" + status.toLowerCase().replace(/\s+/g, "-");
  };

  const handleNavigate = () => {
    navigate("/mon-compte", { state: { account: accountData } });
  };

  const getAllClientTransaction = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const request = {
        accountId: accountData.id,
        numberTransaction: 10,
      };

      const requestData = {
        serviceReference: "GET_ALL_CLIENT_TRANSACTION",
        requestBody: JSON.stringify(request),
      };

      const response = await apiRequest(
        "GATEWAY",
        "",
        "POST",
        requestData,
        userData.token,
        dispatch,
        navigate
      );

      if (response?.status === 200) {
        setTransactionData(response.body.data || []);
      } else {
        setError(t("Erreur lors de la récupération des transactions"));
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setError(t("Une erreur est survenue"));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (accountData?.id) {
      getAllClientTransaction();
    }
  }, [accountData?.id]);

  if (!accountData) {
    return (
      <div className="historique-container historique-error-container">
        <p>{t("Aucune donnée de compte disponible")}</p>
        <button
          onClick={() => navigate("/mon-compte")}
          className="historique-button"
        >
          {t("Retour")}
        </button>
      </div>
    );
  }

  return (
    <div className="historique-container">
      <div className="historique-beneficiary-account">
        <div className="historique-overlay-text">
          {accountData.savingPlanDescription}
        </div>
      </div>

      <div className="historique-details">
        <div className="historique-header">
          <h2>{t("transactionTitle")}</h2>
          <div className="historique-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="currentColor"
              className="bi bi-clock-history"
              viewBox="0 0 16 16"
            >
              <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.255.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z"/>
              <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8 8 0 1 1 8 0z"/>
              <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5"/>
            </svg>
          </div>
        </div>

        <div className="historique-summary">
          <div className="historique-summary-item">
            <label>{t("amountSave")}</label>
            <p className="historique-balance">
              {formatAmount(accountData.balance)}
            </p>
          </div>
          <div className="historique-summary-item">
            <label>{t("lastTransaction")}</label>
            <p>{accountData.lastOperationType || t("Aucune transaction")}</p>
          </div>
        </div>

        {isLoading ? (
          <div className="historique-loading">
            <div className="historique-loading-spinner"></div>
            <p>{t("Chargement des transactions...")}</p>
          </div>
        ) : error ? (
          <div className="historique-error">
            <p>{error}</p>
            <button
              onClick={getAllClientTransaction}
              className="historique-retry-button"
            >
              {t("Réessayer")}
            </button>
          </div>
        ) : transactionData.length === 0 ? (
          <div className="historique-empty">
            <div className="historique-empty-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#7f8c8d" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
            </div>
            <p>{t("Aucune transaction disponible")}</p>
          </div>
        ) : (
          <div className="historique-list-container">
            <div className="historique-list-header">
              <div className="historique-header-item">{t("Date")}</div>
              <div className="historique-header-item">{t("Type")}</div>
              <div className="historique-header-item historique-align-right">
                {t("amount")}
              </div>
              <div className="historique-header-item">{t("Statut")}</div>
            </div>

            <div className="historique-list">
              {transactionData.map((transaction, index) => (
                <div
                  key={transaction.id}
                  className={`historique-item ${index % 2 === 0 ? 'historique-item-even' : 'historique-item-odd'}`}
                >
                  <div className="historique-date">
                    {formatDate(transaction.dateTimeCreation)}
                  </div>
                  <div className="historique-type">
                    <span className="historique-type-icon">
                      {getTransactionIcon(transaction.type)}
                    </span>
                    {getTransactionLabel(transaction.type)}
                  </div>
                  <div
                    className={`historique-amount historique-align-right ${getTransactionClass(
                      transaction.type
                    )}`}
                  >
                    {formatAmount(transaction.amount)}
                  </div>
                  <div className="historique-status">
                    <span
                      className={`historique-status-badge ${getStatusClass(
                        transaction.status
                      )}`}
                    >
                      {t(transaction.status)}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="historique-actions">
          <button className="historique-button" onClick={handleNavigate}>
            {t("backAccount")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HistoriqueTransaction;
